import * as React from 'react';
import type { SVGProps } from 'react';

const SvgRing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={23} {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#ED403A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
    >
      <path d="M10.5 3.803c3.816 0 6.91 2.686 6.91 6v6c0 1.105 1.03 4 2.302 4H1.288c1.272 0 2.303-2.896 2.303-4v-6c0-3.314 3.093-6 6.909-6ZM8.773 19.803c0 1.004.773 1.818 1.727 1.818h0c.954 0 1.727-.814 1.727-1.818M11.652 3.803V2.591c0-.67-.516-1.212-1.152-1.212-.636 0-1.152.542-1.152 1.212v1.212M4 17h13" />
    </g>
  </svg>
);
export default SvgRing;
